import { render } from "./About.vue?vue&type=template&id=53fbc5b0"
const script = {}
script.render = render

export default script